import React from "react";
import { deBaseAFechaLocal, mostrarNombreMes, mostrarNombreOrigen } from "../../utils/Tools";

const Titulo = (props) => {
  const {
    idGrupo,
    promociones,
    destino,
    cantidadProductos,
    origen,
    nombreDestino,
    nombreGrupo,
    fecha,
    fechaIn,
    fechaOut,
    isCdr = false
  } = props;

  return (
    <div className="resultados">
      {idGrupo && <h1>Paquetes para {nombreGrupo}</h1>}
      {promociones && <h1>Promociones de último momento</h1>}
      {!isCdr && destino && destino !== "0" && (
        <h1>
          {cantidadProductos} Paquetes saliendo de {mostrarNombreOrigen(origen)}{" "}
          hacia {nombreDestino}, para {mostrarNombreMes(fecha)}.
        </h1>
      )}
      {isCdr && destino && (
        <h1>
          {`${cantidadProductos} hoteles disponibles desde ${deBaseAFechaLocal(fechaIn)} 
          hasta ${deBaseAFechaLocal(fechaOut)}.`}
        </h1>
      )}
    </div>
  );
};

export default Titulo;



// WEBPACK FOOTER //
// ./src/components/Resultados/titulo.js